/*
 * Static files under /public are served with long-lived immutable
 * Cache-Control headers (see apps/egged/next.config.js), so CDNs and
 * browsers keep serving the old bytes after an asset is replaced in
 * place. Bump the version whenever such an asset's content changes
 * (e.g. the 2026 rebrand logo swap) to force a fresh URL.
 */
export const REBRAND_ASSET_VERSION = 2

export function versionedAsset(
  src: string,
  version: number = REBRAND_ASSET_VERSION,
): string {
  return `${src}?v=${version}`
}
